import React, { useEffect } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { getAccountProfileLink } from "../../../../../components/Navigation/Links";
import { useNavigateInternally } from "../../../../../components/Navigation/Hooks";
import LoadingIndicator from "../../../../../components/Shared/LoadingIndicator";
import { useRootStore } from "../../../../../shared/general/hooks";

export const OrganizationSignUpSuccessRedirectionStep: React.FC<StepRenderProps<
    {},
    IOrganizationSignUpFlowValues
>> = ({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

        /********* React hooks *********/

        const rootStore = useRootStore();
        const userStore = rootStore.userStore;
        const navigate = useNavigateInternally();

        useEffect(() => {
            setOrganizationProfileAsActiveProfile();
        }, [])

        const setOrganizationProfileAsActiveProfile = async () => {
            const organizationProfile = userStore.user.organizationProfile;
            if (organizationProfile) {
                const result = await userStore.updateUserProfileStatus(userStore.user.id, organizationProfile.id, 'active');
                navigateToProfile();
            }
        }

        const navigateToProfile = () => {
            navigate(getAccountProfileLink());
        }

        /********* Render *********/

        return <LoadingIndicator />;
    };
